import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import {
    TableHead,
    Grid,
    FormControl,
    InputAdornment,
    FilledInput,
    InputLabel,
    IconButton,
    Container,
    CircularProgress,
} from '@material-ui/core';
import Search from '@material-ui/icons/Search';

import styles from './styles';
import { KeyboardDatePicker } from '@material-ui/pickers';
const useStyles = makeStyles(styles);

export default function CustomPaginationActionsTable(props) {
    const classes = useStyles();
    const theme = useTheme();

    const {
        loading,
        rows,
        emptyRows,
        hideHeader,
        hideFilterOrder,
        columns,
        placeholderSearch,
        onChangePage,
        onChangeRowsPerPage,
        onBlurSearch,
        onChangeSearch,
        onClickOrder,
        pagination,
        onClickRow,
        initialDate,
        finalDate,
        onChangeInitialDate,
        onChangeFinalDate,
        hideOrder,
        hideItemOrder,
        hideInitialDate,
        hideFinalDate,
        hidePagination,
        backgroundHeadColor,
    } = props;

    const buscaAtual = sessionStorage.getItem('buscaAtual');

    return (
        <>
            {!hideFilterOrder && (
                <Container>
                    <Grid container spacing={2} className={classes.filterPanel}>
                        <Grid item xs={12} sm={3}>
                            {!hideOrder && (
                                <>
                                    Ordenar por Data
                                    <div>
                                        <IconButton
                                            size="small"
                                            onClick={() => !!onClickOrder && onClickOrder('dtCadastro', 'asc')}>
                                            <ArrowDropUpIcon />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            onClick={() => !!onClickOrder && onClickOrder('dtCadastro', 'desc')}>
                                            <ArrowDropDownIcon />
                                        </IconButton>
                                    </div>
                                </>
                            )}
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            {!hideInitialDate && (
                                <KeyboardDatePicker
                                    format="DD/MM/YYYY"
                                    margin="dense"
                                    label="Data inicial"
                                    autoOk
                                    clearable
                                    invalidLabel="Data inválida"
                                    invalidDateMessage="Data inválida"
                                    maxDateMessage="Data inválida"
                                    minDateMessage="Data inválida"
                                    clearLabel={'Limpar'}
                                    value={initialDate}
                                    onChange={onChangeInitialDate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    className={classes.dates}
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            {!hideFinalDate && (
                                <KeyboardDatePicker
                                    format="DD/MM/YYYY"
                                    margin="dense"
                                    label="Data final"
                                    autoOk
                                    clearable
                                    invalidLabel="Data inválida"
                                    invalidDateMessage="Data inválida"
                                    maxDateMessage="Data inválida"
                                    minDateMessage="Data inválida"
                                    clearLabel={'Limpar'}
                                    value={finalDate}
                                    onChange={onChangeFinalDate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    className={classes.dates}
                                />
                            )}
                        </Grid>

                        <Grid item xs={12} sm={3} className={classes.alignRight}>
                            <FormControl size="small" className={classes.search} variant="filled">
                                <InputLabel>{placeholderSearch}</InputLabel>
                                <FilledInput
                                    id="outlined-adornment-weight"
                                    defaultValue={buscaAtual ? buscaAtual : ''}
                                    onBlur={onBlurSearch}
                                    onChange={onChangeSearch}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <Search />
                                        </InputAdornment>
                                    }
                                    aria-describedby="outlined-weight-helper-text"
                                    inputProps={{
                                        'aria-label': 'weight',
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={3}></Grid>
                    </Grid>
                </Container>
            )}
            <TableContainer>
                <Table className={classes.table} aria-label="custom pagination table">
                    {!hideHeader && columns && (
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => {
                                    return (
                                        <TableCell
                                            key={`column-${column.title}`}
                                            align={column.align}
                                            className={classes.headCell}
                                            style={{
                                                minWidth: column.style?.minWidth ? column.style.minWidth : '0',
                                                backgroundColor: backgroundHeadColor
                                                    ? backgroundHeadColor
                                                    : theme.palette.primary.middle,
                                            }}>
                                            {column.title}
                                            {!hideItemOrder && (
                                                <div>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() =>
                                                            !!onClickOrder && onClickOrder(column.field, 'asc')
                                                        }>
                                                        <ArrowDropUpIcon />
                                                    </IconButton>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() =>
                                                            !!onClickOrder && onClickOrder(column.field, 'desc')
                                                        }>
                                                        <ArrowDropDownIcon />
                                                    </IconButton>
                                                </div>
                                            )}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                    )}
                    <TableBody>
                        {loading && (
                            <TableRow>
                                <TableCell colSpan={columns.length} align="center" component="td" scope="row">
                                    <div className={classes.centerProgress}>
                                        <CircularProgress size={20} />
                                    </div>
                                </TableCell>
                            </TableRow>
                        )}
                        {!loading && (
                            <>
                                {rows.map((row, indexRow) => (
                                    <TableRow
                                        hover
                                        key={`row-${indexRow}`}
                                        onClick={(event) => onClickRow(event, { ...row, _index: indexRow })}
                                        style={{ cursor: 'pointer' }}>
                                        {columns.map((column, indexColumn) => {
                                            return (
                                                <TableCell
                                                    key={`cell-${indexColumn}-${indexRow}`}
                                                    align={column.align}
                                                    component="td"
                                                    scope="row"
                                                    className={classes.tableCell}>
                                                    {row[column.field]}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                ))}
                            </>
                        )}
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 73 * emptyRows }}>
                                <TableCell colSpan={columns.length} />
                            </TableRow>
                        )}
                    </TableBody>
                    {!hidePagination && (
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    colSpan={columns.length}
                                    count={pagination?.totalElements ? pagination.totalElements : 0}
                                    rowsPerPage={
                                        pagination?.pageable && pagination?.pageable.pageSize
                                            ? pagination.pageable.pageSize
                                            : 10
                                    }
                                    page={
                                        pagination?.pageable && pagination?.pageable.pageNumber
                                            ? pagination.pageable.pageNumber
                                            : 0
                                    }
                                    SelectProps={{
                                        inputProps: { 'aria-label': 'rows per page' },
                                        native: true,
                                    }}
                                    onPageChange={onChangePage}
                                    onRowsPerPageChange={onChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    )}
                </Table>
            </TableContainer>
        </>
    );
}
